import { axios } from '@pukka/auth';
import { MOKA_GOAUTH_SERVICE } from '@pukka/common/constants';
import { useQuery } from '@tanstack/react-query';

import { BillingModel } from '../../models';

const BILLINGS_URL = `${MOKA_GOAUTH_SERVICE}/api/v1/billings`;

async function fetchBillingHistory() {
  const resp = await axios.get(BILLINGS_URL);

  return resp.data;
}

function useBillingHistory() {
  return useQuery<BillingModel.HistoryResponse>(['billing-history'], fetchBillingHistory);
}

export { BILLINGS_URL, fetchBillingHistory, useBillingHistory };
